export default __webpack_public_path__ + "static/media/add_localAsset.ba9695c4.png";